/* Source-backed galleries only. No variant, option, price or cart mutation. */
(() => {
  'use strict';
  if (window.__pdsProductGalleries) return;
  window.__pdsProductGalleries = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gallery-photo],[data-builder-gallery-photo]');
    if (!button) return;
    const master = button.closest('[data-high-product]');
    const builder = button.closest('.bb-product-gallery');
    const root = master || builder;
    const anchor = master ? root.querySelector('[data-high-photo]') : root?.querySelector('[data-builder-gallery-link]');
    const image = anchor?.querySelector('img');
    if (!root || !anchor || !image || !button.dataset.src) return;
    anchor.hidden = false;
    if (master) master.querySelector('.gallery').hidden = false;
    anchor.href = button.dataset.href;
    anchor.dataset.mediaId = button.dataset.mediaId || '';
    image.alt = button.dataset.alt;
    image.width = Number(button.dataset.width);
    image.height = Number(button.dataset.height);
    if (button.dataset.srcset) image.srcset = button.dataset.srcset;
    else image.removeAttribute('srcset');
    image.src = button.dataset.src;
    root.querySelectorAll('[data-gallery-photo],[data-builder-gallery-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    const caption = root.querySelector(master ? '[data-high-photo-state]' : '[data-builder-gallery-caption]');
    if (caption) caption.textContent = button.dataset.alt + (master ? '. Gallery photograph; your selected options are unchanged.' : '. Quantities and dimensions follow your planner selection.');
  });
})();
